import { render, staticRenderFns } from "./contract.vue?vue&type=template&id=09acd4c4&"
import script from "./contract.js?vue&type=script&lang=js&"
export * from "./contract.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09acd4c4')) {
      api.createRecord('09acd4c4', component.options)
    } else {
      api.reload('09acd4c4', component.options)
    }
    module.hot.accept("./contract.vue?vue&type=template&id=09acd4c4&", function () {
      api.rerender('09acd4c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/contract/contract.vue"
export default component.exports